import { Component, EventEmitter, HostBinding, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { createDate } from 'app/_utils/general-utils';

declare const formatDateToDDMMYYYY: any;

@Component({
    selector: 'input-date-component', templateUrl: './input-date.component.html', styleUrls: ['./input-date.component.scss'], encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputDateComponent {
    @Input() control: FormControl = new FormControl();
    @Input() label: string = '';
    @Input() placeholder: string = 'elemento.generico-input.placeholder-simplified';
    @Input() minDate: NgbDate;
    @Input() maxDate: NgbDate;

    dateSelect(date: NgbDate): void {
        this.control.setValue(formatDateToDDMMYYYY(createDate(date)));
        this.control.markAsTouched();
    }
}
